import { Component } from '@angular/core';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-label',
    standalone: false,
    templateUrl: './label.component.html',
})
export class LabelComponent extends InputComponent {}
